// import { acceptHMRUpdate, defineStore } from 'pinia'

/**
 * Genera URL del tema PrimeVue in base al nome tema
 * Colore fisso: green (compatibile con colori Redigo negli override)
 */
export function updateTheme(themeName: string) {
	const FIXED_COLOR = 'green' // Colore fisso per tutti i temi
	return `https://cdn.jsdelivr.net/npm/primevue@3.15.0/resources/themes/${themeName}-${FIXED_COLOR}/theme.min.css`
}

type ImageKey = 'logo_login' | 'logo_login_title' | 'logo_home'

export const useThemeStore = defineStore('theme', {
	// State
	state: () => ({
		imageCollections: {
			logo_login: '',
			logo_login_title: '',
			logo_home: ''
		},
		// Nome tema: 'saga' (light), 'vela' (dark), 'arya' (dark scuro)
		themeName: 'vela',
		// URL tema PrimeVue corrente
		link: ''
	}),
	// Getters
	getters: {
		/**
		 * Ritorna il nome del tema corrente (es. 'saga', 'vela', 'arya')
		 * Nota: colore ora fisso, non più incluso
		 */
		theme: (state) => {
			return state.themeName
		},

		/**
		 * True se il tema corrente è dark mode (vela o arya)
		 */
		isDarkMode: state => state.themeName !== 'saga',
		getLogoModeDarkLight: (state) => { //  creata ma non usata
			if (state.themeName === 'saga') {
				return appConfig.infoapp.imgLogo.replace('light', 'dark')
			} else {
				return appConfig.infoapp.imgLogo.replace('dark', 'light')
			}
		},
		getLogo: (state) => {
			if (state.imageCollections.logo_home) {
				return state.imageCollections.logo_home
			} else {
				return appConfig.infoapp.imgLogo
			}
		},
		getLogoClass: (state) => {
			if (!state.imageCollections.logo_home) {
				return 'ml-2'
			}
			return ''
		},
		getImageCollections: (state) => {
			return state.imageCollections
		},
		getImageByName: state => (name: ImageKey) => {
			return state.imageCollections[name]
		},
		getLoadLogoHome: (state) => {
			return state.imageCollections.logo_home !== ''
		}
	},
	// optional actions
	actions: {
		setImageCollectionsFromUser(jsonValue?: string) {
			if (!jsonValue) {
				return
			}
			const decodeJSON = JSON.parse(jsonValue)
			this.imageCollections.logo_login = decodeJSON.logo_login
			this.imageCollections.logo_login_title = decodeJSON.logo_login_title
			this.imageCollections.logo_home = decodeJSON.logo_home
		},
		/**
		 * Imposta opzioni tema da preferenze utente
		 * Accetta JSON con { themeMode: 'light' | 'dark' }
		 * Nota: il colore è ora fisso (green), solo il mode cambia
		 */
		setOptionFromUser(jsonValue?: string) {
			if (!jsonValue) {
				this.link = updateTheme(this.themeName)
				return
			}

			try {
				const { themeMode } = JSON.parse(jsonValue)

				if (themeMode === 'light') {
					this.setLight()
				} else if (themeMode === 'dark') {
					this.setDim()
				} else {
					// Default: imposta tema corrente
					this.link = updateTheme(this.themeName)
				}
			} catch (error) {
				console.error('Error parsing theme options:', error)
				this.link = updateTheme(this.themeName)
			}
		},
		/**
		 * Imposta tema dark (Arya) - più scuro di vela
		 */
		setDark() {
			this.themeName = 'arya'
			this.link = updateTheme(this.themeName)
		},

		/**
		 * Imposta tema dark (Vela) - default dark mode
		 */
		setDim() {
			this.themeName = 'vela'
			this.link = updateTheme(this.themeName)
		},

		/**
		 * Imposta tema light (Saga)
		 */
		setLight() {
			this.themeName = 'saga'
			this.link = updateTheme(this.themeName)
		},

		/**
		 * Toggle tra light e dark mode
		 */
		toggleTheme() {
			if (this.themeName === 'saga') {
				this.setDim()
			} else {
				this.setLight()
			}
		}
	}
})

// if (import.meta.hot) { import.meta.hot.accept(acceptHMRUpdate(useThemeStore, import.meta.hot)) }
